import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import ConfigureRules from "./ConfigureRules";
import Activation from "./Activation";
import ControlCriteria from "./ControlCriteria";
import MonitoringFrequency from "./MonitoringFrequency";
import FrequencyForm from "./FrequencyForm";
import HttpRequest200to399 from "./HttpRequest200to399";
import HttpsRequestSuccessful from "./HttpsRequestSuccessful";
import TcpConnection from "./TcpConnection";
import PingCheck from "./PingCheck";

export const typeOfMonitorOptions = [
  {
    name: "machineToMachine",
    heading: "Machine To Machine",
  },
  {
    name: "network",
    heading: "Network",
  },
  {
    name: "network2",
    heading: "Network 2",
  },
];

export const configureRulesOptions = [
  {
    name: "passThroughAllData",
    heading: "Pass through all data",
    info: (
      <div>
        <div className="fw-bold">About Pass through all data </div>
        <div>
          Allow all incoming monitoring data to pass through without filtering
          or restrictions, ensuring complete visibility for analysis or storage.
        </div>
      </div>
    ),
  },
  {
    name: "createParsingDataRules",
    heading: "Create Parsing data rules",
    info: (
      <div>
        <div className="fw-bold">About Create Parsing data rules</div>
        <div>
          Define rules to filter, interpret, and transform incoming monitoring
          data into actionable information. Parsing rules help extract key
          details, standardise formats, and route data to the right workflows.
        </div>
      </div>
    ),
  },
];
export const howtoActivateOptions = [
  {
    name: "activateImmedately",
    heading: "Activate immediately",
    info: (
      <div>
        <div className="fw-bold">About Activate immediately </div>
        <div>
          Enable the service or rule to start working right away upon
          configuration, applying changes instantly without delay.
        </div>
      </div>
    ),
  },
  {
    name: "inboundAlertsReceived",
    heading: "Only activate when [No.] of inbound alerts received",
    info: (
      <div>
        <div className="fw-bold">Abbout inbound alerts received</div>
        <div>
          The workflow is activated when a specified quantity of the same
          inbound alert is received
        </div>
      </div>
    ),
  },
  {
    name: "inboundAlertsReceivedSTET",
    heading:
      " Only activate when inbound alerts received between [ST] and [ET]",
    info: (
      <div>
        <div className="fw-bold">About inbound alerts received... </div>
        <div>
          The workflow is only activated if the inbound alert is received
          between designated times
        </div>
      </div>
    ),
  },
];

function MonitoringDetails({ monitor, setMonitor, selectedApiDetails }) {
  return (
    <div>
      {/* <Row className="mt-3 mx-5">
        <Col xl={5} className="border-end">
          <ConfigureRules
            configureRules={monitor.configureRules}
            setConfigureRules={(value) => {
              setMonitor({ ...monitor, configureRules: value });
            }}
          />

          {monitor.configureRules?.name === "passThroughAllData" && (
            <div className="py-3">
              <Activation
                howtoActivate={monitor.howtoActivate}
                setHowtoActivate={(value) => {
                  setMonitor({ ...monitor, howtoActivate: value });
                }}
              />
            </div>
          )}
        </Col>
        <Col xl={7}>
          {monitor.howtoActivate?.name === "inboundAlertsReceived" && (
            <div className="align-items-center rounded-3 p-4 bg-purple-gradient-darker-reverse w-75 px-5 mx-auto mb-3">
              <div className="my-2">
                <Form.Group className="mb-2" controlId="quantity">
                  <Form.Label className="fw-bold">
                    Number of inbound alerts :
                  </Form.Label>
                  <Form.Control type="text" />
                </Form.Group>
              </div>
            </div>
          )}
          {monitor.howtoActivate?.name === "inboundAlertsReceivedSTET" && (
            <div className="align-items-center rounded-3 p-4 bg-purple-gradient-darker-reverse w-75 px-5 mx-auto mb-3">
              <Form.Group className="mb-2" controlId="startTime">
                <Form.Label className="fw-bold">Start time :</Form.Label>
                <Form.Control type="text" />
              </Form.Group>

              <Form.Group className="mb-2" controlId="endTime">
                <Form.Label className="fw-bold">End Time :</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </div>
          )}
          {monitor.howtoActivate?.name && <ControlCriteria />}{" "}
        </Col>
      </Row>{" "} */}
      <Row className=" mt-3">
        {monitor.Kind === "ping" && (
          <>
            <Col xl={5} xs={12} className="border-end">
              <div className="me-xl-5 mb-2 mb-xl-0">
                <PingCheck
                  check={
                    monitor.MonitorPings?.find(
                      (p) => p.PingKind === "liveness"
                    ) || {}
                  }
                  setCheck={(value) => {
                    setMonitor({
                      ...monitor,
                      MonitorPings: [
                        value,
                        ...(monitor.MonitorPings?.filter(
                          (p) => p.PingKind !== "liveness"
                        ) || []),
                      ],
                    });
                  }}
                  checkType="liveness"
                />
              </div>
              <div className="me-xl-5 mb-2 mb-xl-0 mt-3">
                <PingCheck
                  check={
                    monitor.MonitorPings?.find(
                      (p) => p.PingKind === "recovery"
                    ) || {}
                  }
                  setCheck={(value) => {
                    setMonitor({
                      ...monitor,
                      MonitorPings: [
                        ...(monitor.MonitorPings?.filter(
                          (p) => p.PingKind !== "recovery"
                        ) || []),
                        value,
                      ],
                    });
                  }}
                  checkType="recovery"
                />
              </div>
            </Col>

            <Col xl={7}>
              <div className="ms-xl-5 mt-xl-2 mb-3">
                <HttpRequest200to399
                  selectedApiDetails={selectedApiDetails}
                  key={
                    !monitor.MonitorPings?.find(
                      (p) => p.PingKind === "recovery"
                    )?.IsActive
                  }
                  monitor={monitor}
                  check={
                    monitor.MonitorPings?.find(
                      (p) => p.PingKind === "liveness"
                    ) || {}
                  }
                  setCheck={(value) => {
                    setMonitor({
                      ...monitor,
                      MonitorPings: [
                        value,
                        ...(monitor.MonitorPings?.filter(
                          (p) => p.PingKind !== "liveness"
                        ) || []),
                      ],
                    });
                  }}
                  checkType="liveness"
                />
              </div>
              <div className="ms-xl-5 mt-xl-2">
                <fieldset
                  disabled={
                    !monitor.MonitorPings?.find(
                      (p) => p.PingKind === "recovery"
                    )?.IsActive
                  }
                >
                  <div
                    style={
                      monitor.MonitorPings?.find(
                        (p) => p.PingKind === "recovery"
                      )?.IsActive
                        ? {}
                        : {
                            opacity: 0.5,
                            webkitFilter: "grayscale(100%)",
                            mozFilter: "grayscale(100%)",
                            msFilter: "grayscale(100%)",
                            oFilter: "grayscale(100%)",
                            filter: "grayscale(100%) blur(2px)",
                          }
                    }
                  >
                    <HttpRequest200to399
                      selectedApiDetails={selectedApiDetails}
                      monitor={monitor}
                      check={
                        monitor.MonitorPings?.find(
                          (p) => p.PingKind === "recovery"
                        ) || {}
                      }
                      setCheck={(value) => {
                        setMonitor({
                          ...monitor,
                          MonitorPings: [
                            ...(monitor.MonitorPings?.filter(
                              (p) => p.PingKind !== "recovery"
                            ) || []),
                            value,
                          ],
                        });
                      }}
                      checkType="recovery"
                    />
                  </div>
                </fieldset>
              </div>
            </Col>
          </>
        )}
      </Row>
      {/* {monitor.howtoActivate?.name === "activateImmedately" && (
        // <Row className="mt-3 mx-5">
        //   <Col xl={5} className=" border-end">
        //     <MonitoringFrequency />
        //   </Col>
        //   <Col xl={7}>
        //     <FrequencyForm
        //       whichDate={monitor.whichDate}
        //       setWhichDate={(value) => {
        //         setMonitor({ ...monitor, whichDate: value });
        //       }}
        //       whichDay={monitor.whichDay}
        //       setWhichDay={(value) => {
        //         setMonitor({ ...monitor, whichDay: value });
        //       }}
        //       howOften={monitor.howOften}
        //       sethowOften={(value) => {
        //         setMonitor({ ...monitor, howOften: value });
        //       }}
        //     />
        //   </Col>
        // </Row>
      )} */}
      {/* <Row className="mb-5 mt-3 p-3">
        <Col xs={5} className="pe-5 border-end">
          <div className="ms-2">
            <span className="fs-4 fw-bold ">
              What do you want to do, if it pins..
            </span>
          </div>

          <div className="mb-3">
            <Dropdown>
              <div className="d-flex">
                <Dropdown.Toggle
                  id="dropdown-monitor-configure"
                  className="bg-white text-black w-100 border-0 d-flex justify-content-between align-items-center"
                >
                  {typeOFMonitor ? (
                    <DropdownButton option={typeOFMonitor} />
                  ) : (
                    <div className="fw-bold text-start fs-5">
                      Please select...
                    </div>
                  )}
                </Dropdown.Toggle>
              </div>

              <Dropdown.Menu className="bg-purple-gradient">
                {typeOfMonitorOptions.map((o) => (
                  <Dropdown.Item href="#/action-1" className="border-bottom">
                    <button
                      type="button"
                      className={`btn rounded-4 w-100`}
                      onClick={(e) => {
                        e.preventDefault();
                        setTypeOFMonitor(o);
                      }}
                    >
                      <div className="d-flex w-100">
                        <DropdownButton option={o} />
                      </div>
                    </button>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Col>
        <Col xs={5} className="pe-5 border-end">
          <div className="ms-2">
            <span className="fs-4 fw-bold ">
              What do you want to do, if it fails to pin
            </span>
          </div>

          <div className="mb-3">
            <Dropdown>
              <div className="d-flex">
                <Dropdown.Toggle
                  id="dropdown-monitor-configure"
                  className="bg-white text-black w-100 border-0 d-flex justify-content-between align-items-center"
                >
                  {typeOFMonitor ? (
                    <DropdownButton option={typeOFMonitor} />
                  ) : (
                    <div className="fw-bold text-start fs-5">
                      Please select...
                    </div>
                  )}
                </Dropdown.Toggle>
              </div>

              <Dropdown.Menu className="bg-purple-gradient">
                {typeOfMonitorOptions.map((o) => (
                  <Dropdown.Item href="#/action-1" className="border-bottom">
                    <button
                      type="button"
                      className={`btn rounded-4 w-100`}
                      onClick={(e) => {
                        e.preventDefault();
                        setTypeOFMonitor(o);
                      }}
                    >
                      <div className="d-flex w-100">
                        <DropdownButton option={o} />
                      </div>
                    </button>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Col>
      </Row> */}
    </div>
  );
}

export default MonitoringDetails;
